<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
// #ifdef APP-PLUS
import APPUpdate from '@/uni_modules/zhouWei-APPUpdate/js_sdk/appUpdate';
// #endif
import _chunkArr from './utils/IM/chunkArr';
// require("sdk/libs/strophe");
let WebIM = (wx.WebIM = require("./utils/IM/WebIM")["default"]);
let disp = require("./utils/IM/broadcast");
let msgStorage = require("./components/chat/msgstorage");
let msgType = require("./components/chat/msgtype");
let logout = false;
import userApi from "./api/users/index.js"
import messageApi from "./api/message/message.js"
import permision from "@/js_sdk/wa-permission/permission.js"

import unReadMsgManageMap from "./utils/IM/unReadMsgManage.js"
import receiveMsgNew from "./utils/IM/receiveMsgNew.js"
import sortConversation from "./utils/IM/sortConversation.js"

// // #ifdef H5
// import vconsole from 'vconsole';
// // #endif

import {
  onGetSilentConfig
} from './components/chat/pushStorage'

// 播放提示音
const innerAudioContext = uni.createInnerAudioContext();
innerAudioContext.src = '/static/mp3/ring.mp3';
innerAudioContext.onPlay(() => {
  ////console.log('开始播放');
});
innerAudioContext.onError((res) => {
  ////console.log('播放失败', res);
});

function ack(receiveMsg) {
  // 处理未读消息回执
  var bodyId = receiveMsg.id; // 需要发送已读回执的消息id

  var ackMsg = new WebIM.message("read", WebIM.conn.getUniqueId());
  ackMsg.set({
    id: bodyId,
    to: receiveMsg.from,
  });
  WebIM.conn.send(ackMsg.body);
}

function onMessageError(err) {
  if (err.type === "error") {
    uni.showToast({
      title: err.errorText,
    });
    return false;
  }

  return true;
}

function getCurrentRoute() {
  let pages = getCurrentPages();
  if (pages.length > 0) {
    let currentPage = pages[pages.length - 1];
    return currentPage.route;
  }
  return "/";
}


// 包含陌生人版本
//该方法用以计算本地存储消息的未读总数。
async function calcUnReadSpot(message) {
  // //console.log('收到消息 未读总数', message)
  let myName = uni.getStorageSync("myUsername");
  let localConversationList = uni.getStorageSync('EASEIM_' + myName + '_conversationList')
  let count = 0
  if (message) {
    let msgtxt = message.contentsType == 'TEXT' ? message.data : ''
    let type = 'txt'
    if (message.contentsType == "CUSTOM") {
      type = 'custom'
      if (message.customEvent == 'image') {
        msgtxt = '[图片]'
      } else if (message.customEvent == 'video') {
        msgtxt = '[视频]'
      } else if (message.customEvent == 'goods') {
        msgtxt = '[商品]'
      } else if (message.customEvent == 'backlist') {
        msgtxt = '[回收记录]'
      } else if (message.customEvent == 'b_backlist') {
        msgtxt = '[回收记录]'
      } else if (message.customEvent == 'b_backclueorder') {
        msgtxt = '[回收订单]'
      } else if (message.customEvent == 'info') {
        msgtxt = '[提示信息]'
      } else if (message.customEvent == 'b_backlink') {
        msgtxt = '[回收链接]'
      } else if (message.customEvent == 'sm_link') {
        msgtxt = '[认证链接]'
      } else if (message.customEvent == 'b_appraiseorder') {
        msgtxt = '[鉴定订单]'
      } else if (message.customEvent == 'b_appraiseordercreate') {
        msgtxt = '[鉴定下单]'
      } else if (message.customEvent == 'audio') {
        msgtxt = '[语音]'
      } else {
        msgtxt = '[其他]'
      }
    }

    if (message && message.type == 'chat') {
      // 单聊
      let curPage = getCurrentPages()
      const pageInfo = curPage[curPage.length - 1]
      const query = pageInfo.options
      // 如果当前在聊天页面，并且对方id一致，不计未读
      if (pageInfo.route == 'pages/chatroom/chatroom' && query.username && JSON.parse(query.username)[
              'your'] ==
          message.from) {
        return
      }
      if (message.from in localConversationList) {
        // 本地有会话
        let num = localConversationList[message.from]
            .unreadMessageNum || 0
        localConversationList[message.from].unreadMessageNum = Number(num) + 1
        localConversationList[message.from].latestMessage = {
          "msg": msgtxt,
          "type": type,
        }
        localConversationList[message.from].latestSendTime = message.time
        // 会话排序  将改变的会话放第一个
        localConversationList = sortConversation(localConversationList, localConversationList[message.from]
            .conversationKey)

      } else {
        // 本地没有会话  生成会话
        let sessionId = ''
        if (myName > message.from) {
          sessionId = myName + message.from
        } else {
          sessionId = message.from + myName
        }
        const {
          data
        } = await uni.WebIM.conn.fetchUserInfoById(message.from)
        let tempObj = {
          "sessionId": sessionId,
          "isTop": '2',
          "conversationType": "singleChat",
          "conversationKey": message.from,
          "conversationInfo": {
            "name": data[message.from].nickname,
            "avatarUrl": data[message.from].avatarurl
          },
          "fromInfo": {
            "fromId": message.from,
            "fromName": data[message.from].nickname
          },
          "targetId": message.from,
          "unreadMessageNum": 1,
          "latestMessage": {
            "msg": msgtxt,
            "type": type
          },
          "latestMessageId": message.id,
          "latestSendTime": message.time
        }
        localConversationList[message.from] = tempObj
        // 会话排序  将改变的会话放第一个
        localConversationList = sortConversation(localConversationList, tempObj.conversationKey)
      }
    } else if (message && message.type == "groupchat" || message.type == "groupChat") {
      // 群聊
      let curPage = getCurrentPages()
      const pageInfo = curPage[curPage.length - 1]
      const query = pageInfo.options
      // 如果当前在聊天页面，并且对方id一致，不计未读
      if (pageInfo.route == 'pages/groupChatRoom/groupChatRoom' && query.username && JSON.parse(query
              .username)['groupId'] ==
          message.to) {
        return
      }
      if (message.to in localConversationList) {
        let num = localConversationList[message.to]
            .unreadMessageNum || 0
        localConversationList[message.to].unreadMessageNum = Number(num) + 1
        localConversationList[message.to].latestMessage = {
          "msg": msgtxt,
          "type": type,
        }
        localConversationList[message.to].latestSendTime = message.time
        // 会话排序  将改变的会话放第一个
        localConversationList = sortConversation(localConversationList, localConversationList[message.to]
            .conversationKey)
      } else {
        // 创建新会话
        const {
          data
        } = await messageApi.getGroupDetailInfo(message.to)
        const fromUser = await uni.WebIM.conn.fetchUserInfoById(message.from)
        let tempObj2 = {
          "sessionId": message.to,
          "isTop": '2',
          "conversationType": "groupChat",
          "conversationKey": message.to,
          "conversationInfo": {
            "name": data.groupName,
            "avatarUrl": ""
          },
          "fromInfo": {
            "fromId": message.from,
            "fromName": fromUser.data[message.from].nickname
          },

          "targetId": message.to,
          "unreadMessageNum": 1,
          "latestMessage": {
            "msg": msgtxt,
            "type": type
          },
          "latestMessageId": message.id,
          "latestSendTime": message.time,
          "groupName": data.groupName,
        }
        localConversationList[message.to] = tempObj2
        // 会话排序  将改变的会话放第一个
        localConversationList = sortConversation(localConversationList, tempObj2
            .conversationKey)
      }
    }
  }

  uni.setStorageSync('EASEIM_' + myName + '_conversationList', localConversationList)
  for (let key in localConversationList) {
    if (localConversationList.hasOwnProperty(key)) {
      // //console.log(key, localConversationList[key]);
      let num = localConversationList[key].unreadMessageNum || 0
      count = count + Number(num)
    }
  }
  // getApp().globalData.unReadMessageNum = count;
  // uni.$emit('unReadMessageNumChange', count)


  // //console.log(disp.fire("em.unreadspot", message););
  //  + Number(getApp().globalData.sysUnreadNum)
  let badgenum = Number(count) + Number(getApp().globalData.sysUnreadNum)
  // //console.log('触发了全局监听方法1，参数为：', badgenum)
  getApp().globalData.unReadMessageNum = badgenum;
  if (badgenum) {
    uni.setTabBarBadge({
      index: 2,
      text: String(badgenum > 99 ? 99 : badgenum)
    })
    // #ifdef APP-PLUS
    plus.runtime.setBadgeNumber(badgenum)
    // #endif
  } else {
    uni.removeTabBarBadge({
      index: 2
    })
    // #ifdef APP-PLUS
    plus.runtime.setBadgeNumber(0)
    // #endif
  }
  disp.fire("em.unreadspot", message);
  // if (count) {
  // 	uni.setTabBarBadge({
  // 		index: 2,
  // 		text: String(count > 99 ? 99 : count)
  // 	})
  // } else {
  // 	uni.removeTabBarBadge({
  // 		index: 2
  // 	})
  // }
}

function saveGroups() {
  var me = this;
  return WebIM.conn.getGroup({
    limit: 99999,
    success: function (res) {
      uni.setStorage({
        key: "listGroup",
        data: res.data,
      });
    },
    error: function (err) {
      ////console.log(err);
    },
  });
}

export default {
  tongzhi: false,
  globalData: {
    showUniLogin: false, //初始化一键登录
    pushClientid: '',
    OAID: '', //APP设备id
    yx_type: '', //手机型号
    firstShow: true,
    remarkList: {}, //当前用户对其他人的备注
    qidongtuxianshi: true,
    reloginNum: 0,
    phoneNumber: '',
    unReadMessageNum: 0,
    userInfo: null,
    userInfoFromServer: null, //用户属性从环信服务器获取
    friendUserInfoMap: new Map(), //好友属性
    saveFriendList: [],
    saveGroupInvitedList: [],
    isIPX: false, //是否为iphone X
    sysUnreadNum: 0, //系统消息未读数
    tipContentAlbum: '用于在发布商品或投诉建议、资料上传、与客服聊天发送图片视频音频、修改头像等场景中使用摄像头、读取和写入相册和文件内容',
    tipContentCamera: '相机权限用于在发布商品或投诉建议、与客服聊天发送图片视频音频等场景中拍照上传',
    tipContentMac: '麦克风权限用于在客服聊天时，发送音频消息使用',
    // 权限使用前提示
    async isHasPermission(permissionKey, fun, fialFun) {
      ////console.log('调用了授权方法')
      // #ifdef APP-PLUS
      let isPermission = await permision.requestAndroidPermission(permissionKey)
      ////console.log('授权结果', isPermission)
      if (isPermission == 1) {
        fun()
      } else {
        fialFun()
      }
      // #endif
      // #ifndef APP-PLUS
      fun()
      // #endif
    },
    conn: {
      closed: false,
      curOpenOpt: {},

      open(opt) {
        // uni.showLoading({
        // 	title: "正在初始化客户端..",
        // 	mask: true,
        // });
        this.curOpenOpt = opt;
        WebIM.conn.open(opt).then((res) => {
          ////console.log('>>>>>登录成功', res)
          //token获取成功，即可开始请求用户属性。
          disp.fire("em.mian.profile.update");
          // disp.fire('get_remarkList');
          // disp.fire("em.mian.friendProfile.update");
          disp.fire("hxLoginSuccess");
          // //console.log('登录成功>>>>>')
          calcUnReadSpot()
        }).catch((err) => {
          ////console.log('>>>>>token获取失败', err)
        });
        this.closed = false;
      },

      reopen() {
        if (this.closed) {
          //this.open(this.curOpenOpt);
          WebIM.conn.open(this.curOpenOpt);
          this.closed = false;
        }
      },
    },
    onLoginSuccess: function (myName) {
      // //console.log('登录成功>>>>>')
      // calcUnReadSpot()
      uni.hideLoading();
      // uni.redirectTo({
      // 	url: "../conversation/conversation?myName=" + myName,
      // });
    },

    getUserInfo(cb) {
      var me = this;

      // if (this.userInfo) {
      // 	typeof cb == "function" && cb(this.userInfo);
      // } else {
      // 	// 调用登录接口
      // 	uni.login({
      // 		success() {
      // 			uni.getUserInfo({
      // 				success(res) {
      // 					me.userInfo = res.userInfo;
      // 					typeof cb == "function" && cb(me.userInfo);
      // 				},
      // 			});
      // 		},
      // 	});
      // }
    },
    checkIsIPhoneX: function () {
      const me = this;
      uni.getSystemInfo({
        success: function (res) {
          // 根据 model 进行判断
          if (res.model && res.model.search("iPhone X") != -1) {
            me.isIPX = true;
          }
        },
      });
    }
  },


  onLaunch(e) {
    // 处理tabBar大按钮
    uni.onTabBarMidButtonTap(() => {
      uni.navigateTo({
        url: "/pages/saleGameList/saleChoose"
      })
    })

    // 第一次打开存储版本号
    // #ifdef APP-PLUS
    let oldCode = uni.getStorageSync('versionCode')
    let codeNew = plus.runtime.versionCode
    if (!oldCode) {
      uni.setStorageSync('versionCode', codeNew)
      plus.runtime.restart()
    } else {
      if (codeNew > oldCode) {
        uni.setStorageSync('versionCode', codeNew)
        uni.showModal({
          title: '提示',
          content: '检测到您已更新版本，请重启应用',
          showCancel: false,
          success: function (res) {
            if (res.confirm) {
              plus.runtime.restart()
            }
          },

        });

      }
    }

    const objphone = uni.getDeviceInfo()
    getApp().globalData.yx_type = objphone.deviceBrand
    // 获取OAID
    plus.device.getOAID({
      success: (oaidObj) => {
        if (oaidObj) {
          getApp().globalData.OAID = oaidObj.oaid

          messageApi.pushYx().then(res => {
            // //console.log('通知后台OAID', oaidObj.oaid, res)
          })
        }
      }
    })


    // #endif
    // 结束版本号相关
    // 推送相关
    // this.listenPushMsgIOS()
    let that = this
    // // #ifdef H5
    // if (process.env.NODE_ENV === 'development' && !this.$vconsole) {
    // 	this.$vconsole = new vconsole()
    // }
    // // #endif
    ////console.log('App Launch')
    let myName = uni.getStorageSync("myUsername");
    // #ifdef APP-PLUS
    // 一键登录预登陆
    // this.preUniLogin()

    // uni-app客户端获取push客户端标记
    uni.getPushClientId({
      success: (res) => {
        let push_clientid = res.cid
        // ////console.log('客户端推送标识:', push_clientid)
        // 储存和绑定cid 别名
        that.getPushClientid2(push_clientid)
        // 请求通知权限
        that.getQuanxian()
        that.onPushMessageFn()
      },
      fail(err) {
        ////console.log('获取cid失败', err)
      }
    })
    // 结束推送相关
    APPUpdate();
    // #endif
    // 调用 API 从本地缓存中获取数据
    // uni.setInnerAudioOption({
    //   obeyMuteSwitch: false
    // });
    var me = this;
    var logs = uni.getStorageSync("logs") || [];
    logs.unshift(Date.now());
    uni.setStorageSync("logs", logs);
    disp.on("em.main.ready", function () {
      calcUnReadSpot();
    });
    disp.on("em.chatroom.leave", function () {
      calcUnReadSpot();
    });
    disp.on("em.chat.session.remove", function () {
      calcUnReadSpot();
    });
    disp.on("em.chat.audio.fileLoaded", function () {
      calcUnReadSpot();
    });
    disp.on("em.main.deleteFriend", function () {
      calcUnReadSpot();
    });
    disp.on("em.chat.audio.fileLoaded", function () {
      calcUnReadSpot();
    }); //
    disp.on("em.mian.profile.update", function () {

      me.fetchUserInfoWithLoginId()
    });
    disp.on("em.mian.friendProfile.update", function () {
      me.fetchFriendInfoFromServer()
    });
    disp.on("get_remarkList", function () {
      me.getRemarksList()
    });
    disp.on("sys_msg_change", function () {
      calcUnReadSpot();
    });
    /* 群组相关监听 */
    WebIM.conn.addEventHandler('groupEvent', {
      onGroupEvent: (groupevent) => {
        // ////console.log('>>>>>>>收到群组事件', groupevent)
      },
      onGroupChange: (group) => {
        ////console.log('>>>>>>>收到群组事件改变>>>>>', group)
        disp.fire('group_update')
      }

    })
    WebIM.conn.listen({

      onOpened(message) {
        ////console.log('初始化环信')
        ////console.log('IM 登录状态2', WebIM.conn.isOpened())
        // if (
        // 	getCurrentRoute() == "pages/login/login" ||
        // 	getCurrentRoute() == "pages/login_token/login_token"
        // ) {
        // 	// me.globalData.onLoginSuccess(
        // 	// 	uni.getStorageSync("myUsername").toLowerCase()
        // 	// );
        // }
      },
      onReconnect() {
        uni.showToast({
          title: "重连中...",
          duration: 2000,
        });
      },

      onDisconnected() {
        ////console.log('断开链接')
        // 断开链接
        userApi.getInfo().then(res => {
          if (res.code == 200) {
            let islogin = WebIM.conn.isOpened()
            ////console.log('IM 登录状态', islogin)
            // 重新登录IM
            // let hxLoginInfo = uni.getStorageSync('hxLoginInfo')
            // 从后台获取hxtoken
            messageApi.getHxToken().then(res2 => {
              ////console.log('res2', res2)
              let obj = {
                hxusername: res.data.hxusername,
                hxtoken: res2.msg
              }
              uni.setStorageSync('hxLoginInfo', obj)
              getApp().globalData.conn.open({
                user: obj.username,
                accessToken: obj.hxtoken,
              })
            })
          } else {
            ////console.log('APP未登录')
          }

        })
      },

      onSocketConnected() {
        uni.showToast({
          title: "socket连接成功",
          duration: 2000,
        });
      },

      onClosed() {
        // uni.showToast({
        // 	title: "退出登录",
        // 	icon: "none",
        // 	duration: 2000,
        // });
        // uni.redirectTo({
        // 	url: "/pages/login/index",
        // });
        // me.globalData.conn.closed = true;
        // WebIM.conn.close();
        // // uni.removeStorageSync('pushStorageData');
        // uni.clearStorageSync();
      },
      // // 群组相关监听
      // onGroupEvent(groupevent) {
      // 	////console.log('>>>>>>>收到群组事件', groupevent)

      // },

      onInviteMessage(message) {
        me.globalData.saveGroupInvitedList.push(message);
        disp.fire("em.invite.joingroup", message); // uni.showModal({
        // 	title: message.from + " 已邀你入群 " + message.roomid,
        // 	success(){
        // 		disp.fire("em.invite.joingroup", message);
        // 	},
        // 	error(){
        // 		disp.fire("em.invite.joingroup", message);
        // 	}
        // });
      },

      onReadMessage(message) {
        //////console.log('已读', message)
      },

      //onPresence为旧版 ，建议参考最新增删好友api文档 ：http://docs-im.easemob.com/im/web/basics/buddy
      onPresence(message) {
        switch (message.type) {
          case "unsubscribe":
            break;
            // 好友邀请列表
          case "subscribe":
            for (let i = 0; i < me.globalData.saveFriendList.length; i++) {
              if (me.globalData.saveFriendList[i].from === message.from) {
                me.globalData.saveFriendList[i] = message;
                disp.fire("em.subscribe");
                return;
              }
            }
            msgStorage.saveReceiveMsg(message, "INFORM"); //存添加好友消息，方便展示通知
            me.globalData.saveFriendList.push(message);
            disp.fire("em.subscribe");

            break;

          case "subscribed":
            uni.showToast({
              title: "添加成功",
              duration: 1000,
            });
            disp.fire("em.subscribed");
            break;

          case "unsubscribed":
            disp.fire("em.unsubscribed", message);
            break;
          case "direct_joined":
            saveGroups();
            uni.showModal({
              title: '温馨提示',
              content: '进入群聊？',
              showCancel: true,
              confirmColor: '#ff6b35',
              success: sure => {
                if (sure.confirm) {
                  var my = uni.getStorageSync("myUsername");
                  var nameList = {
                    myName: my,
                    your: message.gid,
                    groupId: message.gid,
                    yourNickName: message.groupName || message.gid
                  };
                  uni.navigateTo({
                    url: "../groupChatRoom/groupChatRoom?username=" +
                        JSON.stringify(nameList),
                  });
                }
              }
            })
            break;
          case "memberJoinPublicGroupSuccess":
            saveGroups();
            uni.showToast({
              title: "已进群",
              duration: 1000,
            });
            break;
          case "invite":
            // 防止重复添加
            for (
                let i = 0; i < me.globalData.saveGroupInvitedList.length; i++
            ) {
              if (me.globalData.saveGroupInvitedList[i].from === message.from) {
                me.globalData.saveGroupInvitedList[i] = message;
                disp.fire("em.invite.joingroup");
                return;
              }
            }
            me.globalData.saveGroupInvitedList.push(message);
            msgStorage.saveReceiveMsg(message, "INFORM"); //存添加好友消息，方便展示通知
            disp.fire("em.invite.joingroup");
            break;
          case "unavailable":
            disp.fire("em.contacts.remove");
            disp.fire("em.group.leaveGroup", message);
            break;

          case "deleteGroupChat":
            disp.fire("em.invite.deleteGroup", message);
            break;

          case "leaveGroup":
            disp.fire("em.group.leaveGroup", message);
            break;

          case "removedFromGroup":
            disp.fire("em.group.leaveGroup", message);
            break;
            // case "changeOwner": {
            // 	////console.log('群主变更')
            // }
            // break;
          default:
            break;
        }
      },


      onRoster(message) {
        // let pages = getCurrentPages();
        // if(pages[0]){
        // 	pages[0].onShow();
        // }
      },


      onCmdMessage(message) {
        ////console.log("onCmdMessage", message);
        // 发送包赔资料cmd
        console.log("发送包赔Cmd")
        disp.fire('f_xsqxdd')

        if (message) {
          if (onMessageError(message)) {
            msgStorage.saveReceiveMsg(message, msgType.CMD);
          }

          ack(message);
          onGetSilentConfig(message);
        }
        if (myName != message.from) {
          innerAudioContext.play()
        }
      },

      onRecallMessage(msg) {
        //console.log('撤回消息》》》》》》》》》》》', msg)
        // 删除本地消息
        // 组装对话id
        disp.fire('recallMsg', msg)
        // 将会话列表的最新消息改为对方撤回一条消息
        let myName = uni.getStorageSync("myUsername");
        let sessionKey = ''
        if (myName == msg.to) {
          // 单聊
          sessionKey = msg.from
        } else {
          // 群聊
          sessionKey = msg.to
        }
        let localConversationList = uni.getStorageSync('EASEIM_' + myName + '_conversationList')
        //console.log('sessionKey', sessionKey)
        //console.log('localConversationList[sessionKey]', localConversationList[sessionKey])
        if (localConversationList[sessionKey]) {
          localConversationList[sessionKey].latestMessage = {
            "msg": '[撤回了一条消息]',
            "type": 'txt'
          }
          localConversationList[sessionKey].unreadMessageNum = localConversationList[sessionKey]
              .unreadMessageNum >
          0 ? localConversationList[sessionKey].unreadMessageNum - 1 : 0
        }
        uni.setStorageSync('EASEIM_' + myName + '_conversationList', localConversationList)
        disp.fire("em.unreadspot");
      },

      // onLocationMessage(message){
      // 	////console.log("Location message: ", message);
      // 	if(message){
      // 		msgStorage.saveReceiveMsg(message, msgType.LOCATION);
      // 	}
      // },
      onTextMessage(message) {
        if (message) {
          if (onMessageError(message)) {
            receiveMsgNew.receiveMsg(message, msgType.TEXT)
          }
          calcUnReadSpot(message);
          ack(message);
          // onGetSilentConfig(message);
        }
        if (myName != message.from) {
          innerAudioContext.play()
        }
      },


      // 收到自定义消息，除文本外都用此消息类型
      onCustomMessage(message) {
        if (message) {
          if (onMessageError(message)) {
            receiveMsgNew.receiveMsg(message, msgType.CUSTOM)
          }
          calcUnReadSpot(message);
          ack(message);
          // onGetSilentConfig(message);
        }
        if (myName != message.from) {
          innerAudioContext.play()
        }
      },

      // 各种异常
      onError(error) {
        ////console.log('错误error', error); // 16: server-side close the websocket connection

        // ////console.log('断开链接')
        getApp().globalData.reloginNum++
        if (getApp().globalData.reloginNum < 2 && error.type == '39') {
          userApi.getInfo().then(res => {
            if (res.code == 200) {
              let islogin = WebIM.conn.isOpened()
              ////console.log('IM 登录状态', islogin)
              // if (!islogin) {
              // 重新登录IM
              // let hxLoginInfo = uni.getStorageSync('hxLoginInfo')
              // 从后台获取hxtoken
              messageApi.getHxToken().then(res2 => {
                ////console.log('res2', res2)
                let obj = {
                  hxusername: res.data.hxusername,
                  hxtoken: res2.msg
                }
                ////console.log('obj', obj)
                uni.setStorageSync('hxLoginInfo', obj)
                getApp().globalData.conn.open({
                  user: obj.hxusername,
                  accessToken: obj.hxtoken,
                })
              })
              // }
            } else {
              ////console.log('APP未登录')
            }

          })
        }
        // // 断开链接

        // if (error.type == WebIM.statusCode.WEBIM_CONNCTION_DISCONNECTED) {
        //   // if(error.type == WebIM.statusCode.WEBIM_CONNCTION_DISCONNECTED && !logout){
        //   // if(WebIM.conn.autoReconnectNumTotal < WebIM.conn.autoReconnectNumMax){
        //   // 	return;
        //   // }
        //   uni.showToast({
        //     title: "websocket 断开",
        //     duration: 1000
        //   });
        //   uni.redirectTo({
        //     url: "../login/login"
        //   });
        //   logout = true;
        //   return;
        // } // 8: offline by multi login

        // if (error.type == WebIM.statusCode.WEBIM_CONNCTION_SERVER_ERROR) {
        //   uni.showToast({
        //     title: "offline by multi login",
        //     duration: 1000
        //   });
        //   uni.redirectTo({
        //     url: "../login/login"
        //   });
        // }

        if (error.type == WebIM.statusCode.WEBIM_CONNCTION_OPEN_ERROR) {
          uni.hideLoading();
          disp.fire("em.error.passwordErr"); // uni.showModal({
          // 	title: "用户名或密码错误",
          // 	confirmText: "OK",
          // 	showCancel: false
          // });
        }

        if (error.type == WebIM.statusCode.WEBIM_CONNCTION_AUTH_ERROR) {
          uni.hideLoading();
          disp.fire("em.error.tokenErr");
        }

        if (error.type == "socket_error") {
          ///sendMsgError
          ////console.log("socket_errorsocket_error", error);
          uni.showToast({
            title: "网络已断开",
            icon: "none",
            duration: 2000,
          });
          disp.fire("em.error.sendMsgErr", error);
        }
      },
    });
    this.globalData.checkIsIPhoneX();
  },
  methods: {
    // 一键登录 预登陆
    preUniLogin() {
      // let that = this
      // uni.preLogin({
      // 	provider: 'univerify',
      // 	success() { //预登录成功
      // 		// 显示一键登录选项
      // 		that.globalData.showUniLogin = true
      // 		////console.log('一键登录初始化成功')
      // 	},
      // 	fail(res) { // 预登录失败
      // 		// 不显示一键登录选项（或置灰）
      // 		// 根据错误信息判断失败原因，如有需要可将错误提交给统计服务器
      // 		that.globalData.showUniLogin = false
      // 		////console.log(res.errCode)
      // 		////console.log(res.errMsg)
      // 	}
      // })
    },
    onPushMessageFn() {
      ////console.log('监听通知消息')
      uni.onPushMessage((res) => {
        // 处理通知消息
        this.pushMsgCheck(res)
      })
    },
    // IOS APP端监听通知
    // listenPushMsgIOS() {
    // 	// #ifdef H5
    // 	uni.webView.getEnv(async (res) => {
    // 		if (res.plus) {
    // 			// APP的webview环境
    // 			window.pushMsg = this.pushMsgCheck
    // 			window.getPushClientid = this.getPushClientid2

    // 			uni.webView.postMessage({
    // 				data: {
    // 					type: 'h5load'
    // 				}
    // 			})

    // 		} else {

    // 		}
    // 	})
    // 	// #endif
    // },
    // 接受cid
    getPushClientid2(push_clientid) {
      ////console.log("收到cid h5：", push_clientid)
      // 储存cid别名
      this.globalData.pushClientid = push_clientid
      // 如果登录，绑定别名，未登录不绑定
      let userInfo = uni.getStorageSync('userInfo')
      let token = uni.getStorageSync('token')
      if (token && userInfo && push_clientid) {
        // #ifdef APP-PLUS
        uniCloud.callFunction({
          name: 'pushMsg',
          data: {
            type: 'cidBindAlias',
            params: [{
              "cid": push_clientid,
              "alias": userInfo.userName
            }]
          }
        }).then(res => {
          ////console.log('绑定别名', res.result)
        });
        // #endif
        // #ifndef APP-PLUS
        messageApi.pushMsg({
          type: 'cidBindAlias',
          params: [{
            "cid": push_clientid,
            "alias": userInfo.userName
          }]
        }).then(res => {
          // uni.showToast({
          // 	title: '绑定别名成功'
          // })
          ////console.log('绑定别名', res.result)
        })
        // #endif


      }
    },
    // 处理不同通知类型跳转不同页面
    pushMsgCheck(res) {
      ////console.log("收到推送消息h5：", res) //监听推送消息
      if (res.type == 'receive') {
        // 在线推送消息
        // #ifdef APP-PLUS
        let params = res.data.payload.text
        ////console.log('消息类型', params)
        if (params) {
          if (params.type != '8000') {
            uni.createPushMessage({
              title: res.data.title,
              content: res.data.content,
              payload: res.data.payload
            })
          }
        }
        // #endif
      } else if (res.type == 'click') {
        // 离线推送消息
        let params = res.data.payload.text
        ////console.log('消息类型', params)
        if (params) {
          // if (params.type == '1000') {
          // 	// 付款成功通知，跳转我的买单>交易中
          // 	uni.navigateTo({
          // 		url: '/pages/order/orderList?orderStatus=4'
          // 	})
          // } else if (params.type == '1001') {
          // 	// 交易成功，跳转我的买单>交易成功
          // 	uni.navigateTo({
          // 		url: '/pages/order/orderList?orderStatus=1'
          // 	})
          // } else if (params.type == '2000') {
          // 	// 商品审核通过，跳转我的卖单>已上架
          // 	uni.navigateTo({
          // 		url: '/pages/mine/myAccount/index?saleState=1'
          // 	})
          // } else if (params.type == '2001') {
          // 	// 商品审核拒绝，跳转我的卖单>审核失败
          // 	uni.navigateTo({
          // 		url: '/pages/mine/myAccount/index?saleState=99'
          // 	})
          // } else if (params.type == '2002') {
          // 	// 商品出售通知，跳转我的卖单>交易中
          // 	uni.navigateTo({
          // 		url: '/pages/mine/myAccount/index?saleState=2'
          // 	})
          // } else if (params.type == '2003') {
          // 	// 卖家 订单交易成功，跳转我的卖单>已出售
          // 	uni.navigateTo({
          // 		url: '/pages/mine/myAccount/index?saleState=3'
          // 	})
          // } else
          if (params.type == '8000') {
            // 聊天
            uni.switchTab({
              url: '/pages/conversation/xitongxiaoxi'
            })
          }
        }
      }
    },
    // 通知权限
    //首先我们需要一个触发，我是在进入页面onReady()生命周期中触发的检测
    getQuanxian() {
      let platform = uni.getSystemInfoSync().platform; //首先判断app是安卓还是ios
      ////console.log(platform);
      let me = this
      if (platform == "ios") { //这里是ios的方法
        // ////console.log("我是iOS");
        // var UIApplication = plus.ios.import("UIApplication");
        // var app = UIApplication.sharedApplication();
        // var enabledTypes = 0;
        // if (app.currentUserNotificationSettings) {
        // 	var settings = app.currentUserNotificationSettings();
        // 	enabledTypes = settings.plusGetAttribute("types");
        // 	////console.log("enabledTypes1:" + enabledTypes);
        // 	if (enabledTypes == 0) { //如果enabledTypes = 0 就是通知权限没有开启
        // 		this.tongzhi = true; //这里是我写的一个弹窗上面有一个跳转开启的按钮，自行添加即可
        // 	}
        // }
        // plus.ios.deleteObject(settings);
      } else if (platform == "android") { //下面是安卓的方法
        ////console.log("我是安卓", plus.android);
        var main = plus.android.runtimeMainActivity();
        var pkName = main.getPackageName();
        var uid = main.getApplicationInfo().plusGetAttribute("uid");
        var NotificationManagerCompat = plus.android.importClass(
            "android.support.v4.app.NotificationManagerCompat"
        );
        //android.support.v4升级为androidx
        if (NotificationManagerCompat == null) {
          NotificationManagerCompat = plus.android.importClass(
              "androidx.core.app.NotificationManagerCompat"
          );
        }
        var areNotificationsEnabled =
            NotificationManagerCompat.from(main).areNotificationsEnabled();
        ////console.log('areNotificationsEnabled', areNotificationsEnabled)
        // 未开通‘允许通知’权限，请求通知权限，如果用户已拒绝通知权限，在消息页面进行提醒
        if (!areNotificationsEnabled) {
          var Intent = plus.android.importClass("android.content.Intent");
          var Build = plus.android.importClass("android.os.Build");
          //android 8.0引导
          if (Build.VERSION.SDK_INT >= 26) { //判断安卓系统版本
            var intent = new Intent("android.settings.APP_NOTIFICATION_SETTINGS");
            setTimeout(() => {
              intent.putExtra("android.settings.extra.EXTRA_APP_PACKAGE", pkName);
            }, 500)
          }
        }
      }
    },
    // 获取所有备注列表
    async getRemarksList() {
      const myId = await uni.WebIM.conn.user
      messageApi.userRemarkList(myId).then(res => {
        if (res.code == 200 && res.rows && res.rows.length) {
          let remarksMap = {}
          for (let i = 0; i < res.rows.length; i++) {
            let remark = res.rows[i]
            let keyid = remark.fromHxId == myId ? remark.toHxId : remark.fromHxId
            remarksMap[keyid] = remark
          }
          this.globalData.remarkList = remarksMap
          disp.fire('update_remarkList_finish', remarksMap)
        } else {
          this.globalData.remarkList = {}
        }
      })
    },
    async fetchUserInfoWithLoginId() {
      const userId = await uni.WebIM.conn.user;
      if (userId) {
        try {
          const {
            data
          } = await uni.WebIM.conn.fetchUserInfoById(userId)
          this.globalData.userInfoFromServer = Object.assign({}, data[userId]);
          disp.fire('update_myInfo', this.globalData.userInfoFromServer)
          ////console.log('更新登录用户属性>>>>>>>>>>', this.globalData.userInfoFromServer)
        } catch (error) {
          ////console.log(error)
          uni.showToast({
            title: "用户属性获取失败",
            icon: "none",
            duration: 2000,
          })
        }

      }
    },
    async fetchFriendInfoFromServer() {
      let friendList = []
      try {
        const res = await uni.WebIM.conn.getContacts()
        friendList = Object.assign([], res?.data)
        if (friendList.length && friendList.length < 99) {
          const {
            data
          } = await uni.WebIM.conn.fetchUserInfoById(friendList)
          this.setFriendUserInfotoMap(data)
        } else {
          let newArr = _chunkArr(friendList, 99)
          for (let i = 0; i < newArr.length; i++) {
            const {
              data
            } = await uni.WebIM.conn.fetchUserInfoById(newArr[i])
            this.setFriendUserInfotoMap(data)
          }
        }
      } catch (error) {
        ////console.log(error)
        uni.showToast({
          title: "用户属性获取失败",
          icon: "none"
        })
      }

    },
    setFriendUserInfotoMap(data) {
      if (Object.keys(data).length) {
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            const values = data[key];
            Object.values(values).length && this.globalData.friendUserInfoMap.set(key, values);
          }
        }
      }
    }
  },
  onShow() {
    ////console.log('App Show')
    if (!this.globalData.firstShow) {
      ////console.log('APP页面显示')
      ////console.log('断开前IM 登录状态', uni.WebIM.conn.isOpened())
      uni.WebIM.conn.close && uni.WebIM.conn.close();
      //增加延时目的是为了，确保连接完全断开再去执行重新openIM操作
      setTimeout(() => {
        let islogin = uni.WebIM.conn.isOpened()
        ////console.log('断开后IM 登录状态', uni.WebIM.conn.isOpened())
        // 从本地获取环信登录信息
        let hxUser = uni.getStorageSync('hxLoginInfo')
        if (hxUser) {
          ////console.log('聊天页面本地环信登录信息', hxUser)
          try {
            getApp().globalData.conn.open({
              user: hxUser.hxusername,
              accessToken: hxUser.hxtoken,
            })
          } catch {
            ////console.log("login feil");
          }
        }
      }, 500)
    } else {
      ////console.log('首次APP页面显示')
      this.globalData.firstShow = false
    }

  },
  onHide: function () {
    ////console.log('App Hide')

  }
}
</script>

<style lang="scss">
/*每个页面公共css */
/* 注意要写在第一行，同时给style标签加入lang="scss"属性 */
@import "uview-ui/index.scss";

body {
  font-family: Microsoft Yahei, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, sans-serif;
  background-color: #f9f9f9 !important;
}

/* #ifdef H5 */
body {
  // max-width: 500px;
  margin: auto;
}

/* #endif */
view {
  user-select: text;
  color: #333;
  box-sizing: border-box;
  font-size: 24rpx;
}

.u-border {
  // border-color: #8585A9 !important;
}

.red {
  color: rgb(255, 70, 70)
}

.blue {
  color: #2979ff;
}

.back-blue {
  background-color: #2979ff;
}

.grep {
  color: #c4c9cf;
}

.tit {
  font-weight: bold
}

.back {
  background-color: #f9f9f9;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.fbt {
  justify-content: space-between;
}


// .uni-page-head {
// 	background-color: #fff !important;
// }

// .uni-page-head .uni-page-head__title{
// 	max-width: 450px;
// 	height: calc(44px + env(safe-area-inset-top));
// 	line-height: calc(44px + env(safe-area-inset-top));
// 	margin: 0 auto;
// 	background-color: #f4f6df;
// }
// .uni-page-head .uni-page-head-bd{
// 	left: 0;
// 	right: 0;
// }
// .uni-page-head .uni-page-head-hd{
// 	z-index: 999;
// }
.cooperate {
  img {
    width: 100%;
  }

  image {
    width: 100%;
  }
}
</style>